<template lang="pug">

div

    //- Navigation
    navigation.top.attached

    //- Headline
    //- .ui.attached.segment
    //-     .ui.two.column.centered.middle.aligned.grid
    //-         .column
    //-             h2.ui.header
    //-                 i.users.icon
    //-                 .content Personen
    //-         .ui.form.column
    //-             input(type='text' placeholder='Ihr Suchbegriff')

    //- Filter
    .ui.secondary
        .ui.labels
            router-link.ui.label(:to='{ name: "persons"}' exact)
                | Alle:
                .ui.detail {{ counts.all }}
            router-link.ui.label(:to='{ name: "persons", query: { isUser: 1 }}' exact)
                | Sind Benutzer:
                .ui.detail {{ counts.isUser }}
            router-link.ui.label(:to='{ name: "persons", query: { isUser: 0 }}' exact)
                | Sind keine Benutzer:
                .ui.detail {{ counts.isNoUser }}

    //- Message wenn keine Personen gefunden
    .ui.bottom.icon.message.no-users(v-if='persons.length === 0')
        i.meh.icon
        .content: .header Keine Personen gefunden

    template(v-else)

        //- Personen
        persons-table.ui.segment(
            v-bind:company-models='companies'
            v-bind:person-models='persons'
        )

        //- Pagination
        .ui.bottom.secondary
            .ui.two.column.grid
                .middle.aligned.column
                    .ui.form
                        .inline.fields(style='margin: 0')
                            label Zeilen pro Seite:
                            .field
                                select.ui.selection.dropdown(ref='pageSizeDropdown')
                                    option(v-for='n in pageSizeOptions' v-bind:key='n' v-bind:value='n') {{ n }}
                .right.aligned.middle.aligned.column(v-if='totalPages > 1')
                    .ui.pagination.menu
                        a.icon.item(v-bind:class='{ disabled: currentPage === 1 }' v-on:click='currentPage > 1 && (currentPage -= 1)')
                            i.left.chevron.icon
                        a.item(
                            v-for='page in totalPages'
                            v-bind:key='page'
                            v-bind:class='{ active: page === currentPage }'
                            v-on:click='currentPage = page'
                        ) {{ page }}
                        a.icon.item(v-bind:class='{ disabled: currentPage === totalPages }' v-on:click='currentPage < totalPages && (currentPage += 1)')
                            i.right.chevron.icon

</template>

<script>
    import store from '@/store'
    import Navigation from '@/components/addresses/Navigation.vue'
    import PersonsTable from '@/components/persons/Table.vue'

    async function load_page(route, { page = 0, size = 20 } = {}) {
        const isUser = route.query.isUser != null ? route.query.isUser : null

        const { persons, total } = await store.dispatch('persons/loadPage', { page, size, isUser })

        const companyIds = [...new Set(persons.map(p => p.company).filter(Boolean))]
        await Promise.all(companyIds.map(id => store.dispatch('companies/loadOne', { id }).catch(() => null)))

        return { persons, total }
    }

    //noinspection JSUnusedLocalSymbols,JSUnusedGlobalSymbols
    export default {

        components: { Navigation, PersonsTable },

        beforeRouteEnter(to, from, next) {
            load_page(to).then(({ persons, total }) => next(vm => {
                vm.pagePersons   = persons
                vm.filteredTotal = total
            }))
        },

        beforeRouteUpdate(to, from, next) {
            this._routeChanging = true
            this.currentPage = 1
            load_page(to, { size: this.itemsPerPage }).then(({ persons, total }) => {
                this.pagePersons   = persons
                this.filteredTotal = total
                this._routeChanging = false
                next()
            })
        },

        created() {
            this._routeChanging = false
        },

        mounted() {
            this._initDropdown()
        },

        updated() {
            this._initDropdown()
        },

        data() {
            return {
                currentPage:     1,
                filteredTotal:   0,
                itemsPerPage:    25,
                pagePersons:     [],
                pageSizeOptions: [25, 50, 100, 250],
            }
        },

        watch: {
            currentPage() {
                if (!this._routeChanging) {
                    this.loadCurrentPage()
                }
            },
            itemsPerPage() {
                if (this.currentPage === 1) {
                    this.loadCurrentPage()
                } else {
                    this.currentPage = 1
                }
            },
        },

        methods: {
            _initDropdown() {
                const el = this.$refs.pageSizeDropdown
                if (!el || $(el).data('module-dropdown')) return
                $(el).dropdown({
                    onChange: (value) => {
                        const n = parseInt(value, 10)
                        if (n !== this.itemsPerPage) {
                            this.itemsPerPage = n
                            this.currentPage = 1
                        }
                    }
                })
            },

            async loadCurrentPage() {
                const { persons, total } = await load_page(this.$route, {
                    page: this.currentPage - 1,
                    size: this.itemsPerPage,
                })
                this.pagePersons   = persons
                this.filteredTotal = total
            }
        },

        computed: {

            counts() {
                return store.getters['persons/counts']
            },

            companies() {
                return store.getters['companies/all']
            },

            persons() {
                return this.pagePersons
            },

            totalPages() {
                return Math.ceil(this.filteredTotal / this.itemsPerPage)
            },

        }

    }

</script>
